import { Component } from 'react';

// Small per-section error boundary — mirrors StepBoundary in ImportFlow.jsx so
// a broken chart or list doesn't crash the whole dashboard.
export class SectionBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[QueueDashboard] section crashed:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center gap-2 py-6 w-full rounded border border-gray-200 bg-white">
          <span className="text-xs text-redColor">
            {this.props.label || 'Section'} crashed: {String(this.state.error?.message || this.state.error)}
          </span>
          <button
            type="button"
            className="text-[11px] px-2.5 py-1 rounded border border-gray-200 hover:bg-lightGrayColor"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
